module.exports = __webpack_public_path__ + "img/turbo_ramen.1fba1765.jpg";